import { getBackendUrl } from "@Utils";
import { useNavigate } from "react-router-dom";
import CardComponent from "../../cubeComponent/html/card";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import widgetMapperInitialData from "./dashboardWidgetMapper";
import { setProjectModalVisiblity } from "../../actions/projectDashboard";
import { setModalVisiblity } from "../../actions/portalDashboard";
import axiosWrapper from "../../services/axiosWrapper";
import _ from "lodash";
import { useTranslation } from "react-i18next";

function DashboardWidgetCard({
  widget,
  widgetName,
  isModalVisible,
  setIsConfigureModalVisible,
  graphIssuesDataByStatus,
  widgetMapper,
  widgetDataFiltered,
  setWidgetMapper,
  saveWidget,
  setSaveWidget,
  setWidgetDataFiltered,
  projectId,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [filterData, setFilterData] = useState({
    RecentFilesTableTile: { skip: 0, take: 5 },
    SpaceTableTile: { skip: 0, take: 5 },
    UserTableTile: { skip: 0, take: 5 },
    InspectionsTableTile: { skip: 0, take: 5 },
    progressUpdatesTableTile: { skip: 0, take: 5 },
    generalFormsTableTile: { skip: 0, take: 5 },
    permitToWorkTableTile: { skip: 0, take: 5 },
    IssuesStatusGraphTile: { skip: 0, take: 5 },
    TaskStatusGraphTile: { skip: 0, take: 5 },
    ReviewsTableTile: { skip: 0, take: 5 },
    ContractsTableTile: { skip: 0, take: 5 },

    EstimateGraphTile: { skip: 0, take: 5 },
    EstimatesTableTile: { skip: 0, take: 5 },
    IssuesTableTile: { skip: 0, take: 5 },
    ProjectCollaborattorsTile: { skip: 0, take: 5 },
    ProjectUsersTile: { skip: 0, take: 5 },
    ProjectTableTile: { skip: 0, take: 5 },
    TransmittalsTableTile: { skip: 0, take: 5 },
    TaskTableTile: { skip: 0, take: 5 },
  });
  const { projectData = {}, portalData = {}, layout = {} } = useSelector((state) => state);
  const dispatch = useDispatch();
  const Component = widget.component;

  const handleDropDownSelect = (args) => {
    if (args.element.innerHTML == "Configure") {
      setIsConfigureModalVisible(true);
    } else if (args.element.innerHTML == "Load Next Data") {
      const data = { ...filterData };
      data[widgetName] = {
        ...data[widgetName],
        skip: data[widgetName].skip + data[widgetName].take,
      };
      setFilterData(data);
    } else if (args.element.innerHTML == "Remove") {
      const widgetFilterData = _.cloneDeep(widgetMapper);
      const filteredData = _.cloneDeep(widgetDataFiltered);
      delete widgetFilterData[widgetName];
      filteredData[widgetName].isAdded = false;
      setWidgetMapper(widgetFilterData);
      setWidgetDataFiltered(filteredData);
      setSaveWidget(true);
      if (isModalVisible) {
        handleMaxMinClick();
      }
    }
  };

  const saveProjectDasboardData = () => {
    const savedData = [];
    const widgetData = {
      ...widgetMapperInitialData({
        projectId,
        portalId: portalData._id,
        layout,
      }),
      ...widgetMapper,
    };
    for (const widgetName in widgetData) {
      const includeField = Object.hasOwn(widgetMapper, widgetName);
      const resultdata = includeField ? widgetMapper[widgetName] : widgetData[widgetName];

      const data = {
        name: widgetName,
        layout: resultdata.layout,
        isAdded: includeField ? resultdata.isAdded : false,
      };
      if (resultdata.type == "EMBEDDED_LINK") {
        data.data = resultdata.data;
        data.type = resultdata.type;
      }
      if (widgetName === "QuickLinksTile") {
        data.availableData = Object.keys(resultdata.availableData);
        data.selectedData = Object.keys(resultdata.selectedData);
      }
      savedData.push(data);
    }

    let payload = {};
    if (projectId) {
      payload = {
        data: savedData,
        type: "PROJECT_DASHBOARD_LAYOUT",
        resourceId: projectId,
        resourceType: "RESOURCE_TYPE_PROJECT",
      };
    } else {
      payload = {
        data: savedData,
        type: "DASHBOARD_LAYOUT",
      };
    }
    axiosWrapper.post(`${getBackendUrl()}/userSettings/saveUserSettings`, payload);
  };

  useEffect(() => {
    if (saveWidget) {
      saveProjectDasboardData();
      setSaveWidget(false);
    }
  }, [saveWidget, widgetMapper]);

  const handleMaxMinClick = () => {
    if (projectId) {
      dispatch(
        setProjectModalVisiblity({
          isModalVisible: !isModalVisible,
          title: widget.title || _.get(widget, "data.title"),
          component: widget.component,
          widget,
          widgetName,
        }),
      );
    } else {
      dispatch(
        setModalVisiblity({
          isModalVisible: !isModalVisible,
          title: widget.title || _.get(widget, "data.title"),
          component: widget.component,
          widget,
          widgetName,
        }),
      );
    }
  };
  return (
    <CardComponent
      cardHeaderText={widget.title || _.get(widget, "data.title")}
      items={widget.propertiesOption}
      enableShareIcon={!!widget.path}
      selectDropDownItem={handleDropDownSelect}
      enableMaxMinIcon={widget.expand}
      maxMinIconName={isModalVisible ? "Minimise" : "maximizeIcon"}
      onViewCLick={() => {
        navigate(widget.path);
      }}
      onMaximizeClick={handleMaxMinClick}
      cardBody={
        <Component
          widget={widget}
          filterData={filterData}
          widgetName={widgetName}
          projectId={projectId}
          portalId={portalData._id}
          projectData={projectData}
          graphIssuesDataByStatus={widget.title == t("Issues by Status") && graphIssuesDataByStatus}
        />
      }
    />
  );
}
export default DashboardWidgetCard;
